import React, { useEffect, useState } from 'react'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import useDebounce from '../../../configurations/commonlib/useDebounce';
import { Link, useParams } from 'react-router-dom';
import { PAGE_SIZE } from '../../../configurations/initUrls';
import Paging from '../../controls/Paging';
import { IoMdOpen } from 'react-icons/io';
import SendEmergencyNow from './SendEmergencyNow';
import { RiEditBoxFill } from 'react-icons/ri';
import StatusContainer from '../../controls/StatusContainer';
import { EOPDConfirmedStatusBg, GetEOPDConfirmedStatusName } from '../../../configurations/enums/EOPDConfirmedStatus';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import LoadingContainer from '../../controls/LoadingContainer';
import { GetEGenderName } from '../../../configurations/enums/EGender';
import useGlobalLoader from '../../../configurations/useGlobalLoader';
import Empty from '../../controls/Empty';

export default function ReceptionEmergency({ isActive, searchTerm, isSearch }) {

    const { start, end } = useGlobalLoader()
    const { centerid } = useParams()
    const toast = useToast()
    const [loding, setLoding] = useState(false)
    const [LastPage, setLastPage] = useState(1);
    const [emergencyData, setEmergencyData] = useState([]);
    const [pagingData, setPagingData] = useState();
    const [lodingCrud, setLodingCrud] = useState(false)
    const [isOpenAdd, setIsOpenAdd] = useState(false)
    const [sendData, setSendData] = useState({
        id: 0,
    })

    const [currentPage, setCurrentPage] = useState(1)


    useEffect(() => {
        if (isActive) {
            onSearch()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSearch])

    const OnPageChange = (e) => {
        setCurrentPage(e)
        GetTodaysEmergency({
            CenterId: centerid,
            PageNo: e,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm
        })
    }

    const onSearch = () => {
        GetTodaysEmergency({
            CenterId: centerid,
            PageNo: 1,
            PageSize: PAGE_SIZE,
            SearchTerm: searchTerm
        })
    }

    const GetTodaysEmergency = (params) => {
        setLoding(true)
        start()
        opdRegisteredCrud.GetTodaysEmergency(params).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setEmergencyData(mdata.data)
                setPagingData(mdata.paging)
                setLastPage(mdata.paging.pageCount)
            } else {
                setPagingData()
                setLastPage(1)
                setEmergencyData([])
                // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setPagingData()
            setLastPage(1)
            setEmergencyData([])
            // toast.open(errors, <MdErrorOutline />, "danger")
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const sendEmergencyInCurrentQueue = (param) => {
        setLodingCrud(true)
        start()
        opdRegisteredCrud.SendEmergencyInCurrentQueue(param).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                onSearch()
                setIsOpenAdd(false)
                toast.open("Sent in top queue successfully!", <IoCheckmarkCircleOutline />, "success")
            } else {
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
                setIsOpenAdd(false)

            }
            setLodingCrud(false)
            end()
        }).catch(errors => {
            // toast.open(errors, <MdErrorOutline />, "danger")
            setIsOpenAdd(false)
            setLodingCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    // Confirm button (status 0) OR "Confirmed" badge
    const renderAction = (item) => (
        item.status == 0 ? (
            <button
                type="button"
                title="Confirm"
                onClick={() => { setSendData(item); setIsOpenAdd(!isOpenAdd) }}
                className="rounded-md bg-brand-500 px-3 py-1.5 text-sm font-medium text-white transition hover:bg-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-600 active:scale-95"
            >
                Confirm
            </button>
        ) : (
            <StatusContainer bg="bg-green-400" text="Confirmed" />
        )
    )

    return (
        <div className="text-gray-700">
            <Paging LastPage={LastPage} CurrentPage={currentPage} OnPageChange={OnPageChange} pagingData={pagingData}>

                {loding ? (
                    <LoadingContainer text="Fetching..." />
                ) : emergencyData.length > 0 ? (
                    <>
                        {/* ===== desktop table ===== */}
                        <div className="hidden overflow-x-auto sm:block">
                            <table className="w-full border-collapse text-left text-sm text-gray-500">
                                <thead>
                                    <tr className="bg-gray-100 text-xs uppercase tracking-wide text-gray-500">
                                        <th scope="col" className="px-3 py-3 font-semibold">Ref.No</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Conf./Old</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Name</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Phone</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Age</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Status</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Action</th>
                                        <th scope="col" className="px-3 py-3 font-semibold">Address</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {emergencyData.map((item, index) => (
                                        <tr key={index} className="bg-white hover:bg-gray-50">
                                            <td className="px-3 py-2.5">{item.id}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">
                                                <span className="font-bold text-green-500">{item.confirmedAllotedNumber}</span>/ {item.opdNumberAlloted}
                                            </td>
                                            <td className="whitespace-nowrap px-3 py-2.5 font-bold text-gray-800">
                                                {item.patientName} <span className="text-[9px] font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </td>
                                            <td className="px-3 py-2.5">{item.mobile}</td>
                                            <td className="px-3 py-2.5">{item.age}</td>
                                            <td className="px-3 py-2.5">
                                                <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
                                            </td>
                                            <td className="px-3 py-2.5">{renderAction(item)}</td>
                                            <td className="whitespace-nowrap px-3 py-2.5">{item.patientAddress}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* ===== mobile cards ===== */}
                        <div className="space-y-2 p-2 text-left sm:hidden">
                            {emergencyData.map((item, index) => (
                                <div key={index} className="border-b-2 border-gray-100 bg-white p-3">
                                    <div className="flex items-start justify-between gap-2">
                                        <div className="min-w-0">
                                            <div className="font-bold text-gray-900">
                                                {item.patientName} <span className="text-xs font-normal text-gray-400">({GetEGenderName(item.gender)})</span>
                                            </div>
                                            <div className="mt-0.5 text-xs text-gray-500">Ref: {item.id} · Age: {item.age}</div>
                                            <div className="mt-0.5 text-xs text-gray-500">
                                                Conf/Old: <span className="font-bold text-green-600">{item.confirmedAllotedNumber}</span>/{item.opdNumberAlloted}
                                            </div>
                                        </div>
                                        <div className="shrink-0">{renderAction(item)}</div>
                                    </div>
                                    <div className="mt-2 space-y-1 text-xs text-gray-600">
                                        <div><span className="text-gray-400">Phone: </span>{item.mobile}</div>
                                        <div><span className="text-gray-400">Address: </span>{item.patientAddress}</div>
                                    </div>
                                    <div className="mt-2">
                                        <StatusContainer bg={EOPDConfirmedStatusBg(item.status)} text={GetEOPDConfirmedStatusName(item.status)} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : (
                    <Empty>No Items Found.</Empty>
                )}
            </Paging>

            <div className="pb-4" />

            <SendEmergencyNow SendEmergencyInCurrentQueue={sendEmergencyInCurrentQueue} sendData={sendData} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} />
        </div>
    )
}